import { render, staticRenderFns } from "./CheckboxWrapper.vue?vue&type=template&id=2acd7c56&"
import script from "./CheckboxWrapper.vue?vue&type=script&lang=js&"
export * from "./CheckboxWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports